// extracted by mini-css-extract-plugin
module.exports = {"container":"ListPlaceholderSeries_container__WcWUz","textLine":"ListPlaceholderSeries_textLine__3iBG4","imgArrow":"ListPlaceholderSeries_imgArrow__3lyEv"};